"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i = void 0;

/**
 * Identity function
 *
 * @param  {mixed}  source  Source input
 *
 * @return {mixed}
 */
var i = function i(source) {
  return source;
};

exports.i = i;